import { StaticImage } from '@/common/constants/displateRoutes';
import { RouteToArtistPage } from '@/common/routes/ExternalRoutes';

export const partners = [
  {
    name: 'Cyberpunk',
    url: RouteToArtistPage({ nick: 'cyberpunk-2077', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_cyberpunk-2077.png'),
  },
  {
    name: 'Star Wars',
    url: RouteToArtistPage({ nick: 'star-wars', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_star-wars.png'),
  },
  {
    name: 'Marvel',
    url: RouteToArtistPage({ nick: 'marvel', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_marvel.png'),
  },
  {
    name: 'DC Comics',
    url: RouteToArtistPage({ nick: 'dc-comics', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_dc-comics.png'),
  },
  {
    name: 'Destiny',
    url: RouteToArtistPage({ nick: 'destiny', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_destiny.png'),
  },
  {
    name: 'Stranger Things Series',
    url: RouteToArtistPage({ nick: 'stranger-things-series', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_stranger-things.png'),
  },
  {
    name: 'Elden Ring',
    url: RouteToArtistPage({ nick: 'elden-ring', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_elden-ring.png'),
  },
  {
    name: 'Wizarding World',
    url: RouteToArtistPage({ nick: 'wizarding-world', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_wizarding-world.png'),
  },
  {
    name: 'Call of Duty',
    url: RouteToArtistPage({ nick: 'call-of-duty', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_call-of-duty.png'),
  },
  {
    name: 'League of Legends',
    url: RouteToArtistPage({ nick: 'league-of-legends', licensed: true }).route,
    image: StaticImage('/images/footer/partners/logo_league-of-legends.png'),
  },
];
